import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-create-schedule-form .tb-form-label', {
    display: 'inline-block',
    verticalAlign: 'top',
    minWidth: '115px',
    lineHeight: '23px',
    textAlign: 'right',
    paddingRight: '12px',
});

cssRule('.tb-create-schedule-form .tb-form-label.tb-form-label-wide', {
    minWidth: '140px',
});

cssRule('.tb-create-schedule-form .tb-form-label.tb-form-label-tall', {
    verticalAlign: 'top',
    lineHeight: 'normal',
    paddingTop: '1px',
});

cssRule('.tb-create-schedule-form .tb-form-value', {
    display: 'inline-block',
});

cssRule('.tb-create-schedule-form-subtitle', {
    marginBottom: '24px',
});

cssRule('.tb-create-schedule-form-subtitle-name', {
    fontWeight: 'normal',
    fontSize: '14px',
});

cssRule('.tb-create-schedule-form-subtitle-divider', {
    padding: '0 9px',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-create-schedule-form-priority .tb-text-box-holder', {
    display: 'inline-block',
    width: '60px',
});

cssRule('.tb-create-schedule-form-serialization', {
    whiteSpace: 'normal',
});

cssRule('.tb-create-schedule-form-serialization label', {
    display: 'block',
});

cssRule('.tb-settings-group.tb-create-schedule-form-frequency', {
    minWidth: '636px',
    minHeight: '150px',
    paddingBottom: 0,
});

cssRule('.tb-settings-group', {
    paddingBottom: '18px',
});

cssRule('.tb-create-schedule-form-type', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '140px',
});

cssRule('.tb-create-schedule-form-type label', {
    display: 'block',
});

cssRule('.tb-create-schedule-form-details', {
    display: 'inline-block',
});

cssRule('.tb-create-schedule-form-details .tb-settings-group', {
    paddingTop: 0,
    paddingBottom: '6px',
});

cssRule('.tb-create-schedule-form-details .tb-settings-group td', {
    padding: '0 0 6px',
});

cssRule('.tb-create-schedule-form-details .tb-settings-group td > span', {
    verticalAlign: 'top',
});

cssRule('.tb-create-schedule-form-details .tb-form-label-cell', {
    textAlign: 'right',
});

cssRule('.tb-create-schedule-form-details .tb-form-label', {
    display: 'inline-block',
    verticalAlign: 'top',
    minWidth: 0,
    paddingRight: 0,
});

cssRule('.tb-create-schedule-form-details .tb-popup-menu', {
    fontSize: '11px',
});

cssRule('.tb-create-schedule-form-hourly', {
    borderCollapse: 'collapse',
});

cssRule('.tb-create-schedule-form-weekly-days, .tb-create-schedule-form-weekly-start-time', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-create-schedule-form-weekly-days', {
    marginRight: '6px',
});

cssRule('.tb-schedule-settings-label', {
    display: 'block',
    fontWeight: 'bold',
    margin: '18px 0',
});

cssRule('.tb-schedule-settings-label:first-child', {
    marginTop: 0,
});

cssRule('.tb-create-schedule-task-type .tb-popup-menu', {
    width: '180px',
});

cssRule('.tb-details .tb-create-schedule-form-weekly-days .tb-checkbox-group', {
    height: '20px',
});

cssRule('.tb-details .tb-create-schedule-form-weekly-days .tb-checkbox-group span', {
    verticalAlign: 'top',
});

cssRule('.tb-details', {
    height: '100%',
    overflow: 'auto',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-details > table', {
    width: '100%',
    maxWidth: '768px',
    paddingRight: '18px',
    marginTop: '12px',
    borderSpacing: 0,
});

cssRule('.tb-details > table > tbody > tr', {
    verticalAlign: 'top',
});

cssRule('.tb-details > table > tbody > tr > td', {
    padding: '12px',
});

cssRule('.tb-details > table .tb-label', {
    width: '1%',
    paddingLeft: '18px',
    textAlign: 'right',
    fontSize: '15px',
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
    lineHeight: '23px',
    whiteSpace: 'nowrap',
});

cssRule('.tb-details > table .tb-details-value', {
    width: '100%',
    paddingTop: '15px',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    lineHeight: '1.35em',
});

cssRule('.tb-details > table .tb-details-value.tb-details-cell-no-border', {
    border: 0,
});

cssRule('.tb-details > table .tb-details-value.tb-radio-button-control', {
    lineHeight: 0,
});

cssRule('.tb-details > table .tb-details-value .tb-create-schedule-form-type', {
    height: '164px',
});

cssRule('.tb-details > table .tb-details-value .tb-disabled', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-details > table .tb-details-button-cell', {
    width: '1%',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-details > table .tb-details-button-cell .tb-outline-button', {
    marginTop: '6px',
});

cssRule('.tb-details > table .tb-details-button-cell .tb-outline-button:first-child', {
    marginTop: 0,
});

cssRule('.tb-details > table .tb-details-button-cell.tb-details-cell-no-border', {
    border: 0,
});

cssRule('.tb-details .tb-about', {
    verticalAlign: 'top',
});

cssRule('.tb-details .tb-details-button-cell .tb-outline-button', {
    display: 'block',
    textAlign: 'center',
    marginTop: '6px',
});

cssRule('.tb-details .tb-details-button-cell .tb-outline-button:first-child', {
    marginTop: 0,
});

cssRule('.tb-details .tb-details-button-cell .tb-outline-button.tb-margin-top-wide', {
    marginTop: '12px',
});

cssRule('.tb-details .tb-details-button-cell button', {
    width: '100%',
});

cssRule('.tb-details .tb-editable-textarea textarea', {
    width: '100%',
    boxSizing: 'border-box',
});

cssRule('.tb-details .tb-tag-row', {
    verticalAlign: 'top',
});

